import { Component, Input, Output, OnChanges, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { WorkItemTypeValue } from 'common/workitems/constants/workitem-types';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { WorkItemsTrackingService } from 'common/workitems/workitems-tracking.service';
import { WorkItemEventParams } from 'common/common/constants/analytics-enums';

@Component({
  selector: 'app-compact-visitor-info',
  templateUrl: './compact-visitor-info.component.html',
  styleUrls: ['./compact-visitor-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CompactVisitorInfoComponent implements OnChanges {
  @Input()
  public canEdit: boolean = false;

  @Input()
  public visitor;

  @Input()
  public hidden = false;

  @Input()
  public workItemId;

  @Output()
  public onEditEmail: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  public onEditPhone: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('emailInput') emailInput: ElementRef;

  @ViewChild('phoneNumberInput') phoneNumberInput: ElementRef;

  public bcEnums;
  public editingEmail: boolean = false;
  public editingPhone: boolean = false;

  private _lastEmail: string;
  private _lastPhone: string;
  private readonly phoneInputAllowed: RegExp = /[^+\(\)\d-. ]/g;

  constructor(private _changeDetector: ChangeDetectorRef, private _workItemsTrackingService: WorkItemsTrackingService) {
    this.bcEnums = bcEnums;
  }

  ngOnChanges() {
    this._workItemsTrackingService.updateDataByItemId(this.workItemId, {
      [WorkItemEventParams.CUSTOMER_INFO_VISIBLE]: !this.hidden
    });
  }

  public editEmail(): void {
    if (this.editingEmail) {
      this.editingEmail = false;
      const value = this.visitor.fields.email.value;
      if (this.emailInput.nativeElement.checkValidity() && value && value !== this._lastEmail) {
        this.onEditEmail.emit(value);
      } else {
        this.visitor.fields.email.value = this._lastEmail;
      }
    } else {
      this.editingEmail = true;
      this._lastEmail = this.visitor.fields.email.value;
      this._changeDetector.detectChanges();
      this.emailInput.nativeElement.focus();
    }
  }

  public editPhone(): void {
    if (this.editingPhone) {
      this.editingPhone = false;
      const value = this.visitor.fields.phoneNumber.value;
      if (value && value !== this._lastPhone) {
        this.onEditPhone.emit(value);
      } else {
        this.visitor.fields.phoneNumber.value = this._lastPhone;
      }
    } else {
      this.editingPhone = true;
      this._lastPhone = this.visitor.fields.phoneNumber.value;
      this._changeDetector.detectChanges();
      this.phoneNumberInput.nativeElement.focus();
    }
  }

  public restrictPhone(): void {
    this._changeDetector.detectChanges();
    this.visitor.fields.phoneNumber.value = this.visitor.fields.phoneNumber.value.replace(this.phoneInputAllowed, '');
  }

  public isChat(): boolean {
    return this.visitor && this.visitor.type === WorkItemTypeValue.CHAT;
  }

  public isEmail(): boolean {
    return this.visitor && this.visitor.type === WorkItemTypeValue.EMAIL;
  }

  public isFacebook(): boolean {
    return this.visitor && this.visitor.type === WorkItemTypeValue.FACEBOOK;
  }

  public isAsyncMessage(): boolean {
    return this.visitor && this.visitor.type === WorkItemTypeValue.ASYNC_MESSAGE;
  }

  public isSms(): boolean {
    return this.visitor && this.visitor.type === WorkItemTypeValue.SMS;
  }
}
